// extracted by mini-css-extract-plugin
export default {"weaponSockets":"_12W3B","perks":"_1rM56","stats":"pJspE"};